import React from 'react'
import './NotFound.scss'

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="error-illustration">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="80" stroke="#E5E7EB" strokeWidth="4" fill="none"/>
            <path d="M70 85C70 80 75 75 80 75C85 75 90 80 90 85" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round"/>
            <path d="M110 85C110 80 115 75 120 75C125 75 130 80 130 85" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round"/>
            <path d="M70 130C70 130 85 115 100 115C115 115 130 130 130 130" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round"/>
          </svg>
        </div>
        <p className="error-help">
          If you believe this is an error, please contact support.
        </p>
      </div>
    </div>
  )
}

export default NotFound
